import styled from '@emotion/styled';

export const ChatOrderProductCandidatesModalStyle = styled.div`
  position: relative;
  padding: 32px;
  width: 480px;
  border-radius: 16px;
  background-color: var(--seed-semantic-color-paper-default);
  display: flex;
  flex-direction: column;
  max-height: 80vh;

  .close-button {
    position: absolute;
    top: 14px;
    right: 20px;
    padding: 3px;
    border: none;
    background: none;
    cursor: pointer;
    color: var(--seed-scale-color-gray-600);
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: var(--seed-scale-color-gray-900);
    }

    svg {
      fill: var(--seed-scale-color-gray-600);
    }
  }

  .title {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 12px;
    color: var(--seed-scale-color-gray-900);
  }

  .info-banner {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background-color: var(--seed-scale-color-gray-100);
    border-radius: 8px;
    margin: 0 0 32px;

    .info-icon {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .info-text {
      font-size: 13px;
      line-height: 1.5;
      color: var(--seed-scale-color-gray-700);
    }
  }

  .post-chip-group {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 4px;
    margin: 0 0 16px;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .post-chip {
    flex-shrink: 0;
    height: 32px;
    padding: 0 14px;
    border: 1px solid var(--seed-scale-color-gray-300);
    border-radius: 999px;
    background: var(--seed-semantic-color-paper-default);
    font-size: 13px;
    font-weight: 500;
    color: var(--seed-scale-color-gray-700);
    cursor: pointer;
    white-space: nowrap;

    &:hover:not(.active) {
      background-color: var(--seed-scale-color-gray-100);
    }

    &.active {
      background-color: var(--seed-scale-color-gray-900);
      border-color: var(--seed-scale-color-gray-900);
      color: #ffffff;
    }
  }

  .product-list {
    flex: 1;
    overflow-y: auto;
    margin-bottom: 16px;
  }

  .product-card {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px 0;

    &:not(:last-child) {
      border-bottom: 1px solid var(--seed-semantic-color-divider-1);
    }
  }

  .product-header {
    display: flex;
    align-items: center;
    gap: 12px;

    .product-thumbnail {
      width: 48px;
      height: 48px;
      border-radius: 8px;
      object-fit: cover;
      flex-shrink: 0;
      border: 1px solid var(--seed-scale-color-gray-100);
    }

    .product-name {
      font-size: 15px;
      font-weight: 400;
      color: var(--seed-scale-color-gray-900);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .selectable-rows {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .selectable-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border: 1px solid var(--seed-scale-color-gray-300);
    border-radius: 12px;
    gap: 12px;
    cursor: pointer;
    user-select: none;

    &:hover:not(.disabled):not(.selected) {
      background-color: var(--seed-scale-color-gray-50, var(--seed-scale-color-gray-100));
    }

    &.selected {
      border-color: var(--seed-scale-color-gray-900);
    }

    &.disabled {
      cursor: not-allowed;
    }

    &:focus-visible {
      outline: 2px solid var(--seed-scale-color-gray-900);
      outline-offset: 2px;
    }
  }

  .quantity-stepper-wrapper {
    display: inline-flex;
    flex-shrink: 0;
  }

  .row-left {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    gap: 12px;
  }

  .row-checkbox {
    width: 20px;
    height: 20px;
    accent-color: var(--seed-scale-color-gray-900);
    cursor: pointer;
    flex-shrink: 0;

    &:disabled {
      cursor: not-allowed;
    }
  }

  .row-label {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }

  .option-name {
    font-size: 14px;
    color: var(--seed-scale-color-gray-900);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .row-price {
    font-size: 15px;
    font-weight: 700;
    color: var(--seed-scale-color-gray-900);
  }

  .no-price-wrapper {
    display: flex;
    gap: 4px;
  }

  .no-price-text {
    font-size: 15px;
    font-weight: 700;
    color: var(--seed-scale-color-gray-900);
  }

  .need-to-write {
    font-size: 13px;
    color: var(--seed-scale-color-gray-500);
  }

  .quantity-stepper {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;

    .stepper-button {
      width: 32px;
      height: 32px;
      border: 1px solid var(--seed-scale-color-gray-300);
      background: var(--seed-semantic-color-paper-default);
      font-size: 16px;
      color: var(--seed-scale-color-gray-600);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &:first-of-type {
        border-radius: 4px 0 0 4px;
      }

      &:last-of-type {
        border-radius: 0 4px 4px 0;
      }

      &:hover:not(:disabled) {
        background-color: var(--seed-scale-color-gray-100);
      }

      &:disabled {
        color: var(--seed-scale-color-gray-300);
        cursor: not-allowed;
      }
    }

    .stepper-value {
      width: 40px;
      height: 32px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: var(--seed-scale-color-gray-900);
      border-top: 1px solid var(--seed-scale-color-gray-300);
      border-bottom: 1px solid var(--seed-scale-color-gray-300);
      line-height: 32px;
    }
  }

  .delivery-fee-section {
    margin-top: 0px;
  }

  .delivery-fee-check {
    display: flex;
    align-items: center;
    gap: 8px;

    input[type='checkbox'] {
      width: 20px;
      height: 20px;
      accent-color: var(--seed-scale-color-gray-900);
      cursor: pointer;

      &:disabled {
        cursor: not-allowed;
      }
    }

    label {
      font-size: 14px;
      color: var(--seed-scale-color-gray-900);
      cursor: pointer;
    }
  }

  .delivery-fee-options {
    display: flex;
    flex-wrap: wrap;
    gap: 2px 16px;
    margin-top: 12px;

    .delivery-fee-option {
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;

      .delivery-fee-radio {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 2px solid var(--seed-scale-color-gray-400);
        display: flex;
        align-items: center;
        justify-content: center;
        background: none;
        box-sizing: content-box;

        &.selected {
          background-color: var(--seed-scale-color-gray-900);
          border-color: var(--seed-scale-color-gray-900);

          &::after {
            content: '';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: white;
          }
        }
      }

      span {
        font-size: 14px;
        color: var(--seed-scale-color-gray-900);
      }
    }
  }

  .button-group {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px 0 0;
    border-top: 1px solid var(--seed-semantic-color-divider-1);

    .direct-input-button {
      height: 40px;
      padding: 8px 16px;
      border: none;
      border-radius: 6px;
      background: none;
      font-size: 16px;
      font-weight: 600;
      color: var(--seed-scale-color-gray-900);
      background-color: var(--seed-scale-color-gray-100);
      cursor: pointer;

      &:hover {
        background-color: var(--seed-scale-color-gray-200);
      }
    }

    .submit-button {
      height: 40px;
      padding: 8px 16px;
      border: none;
      border-radius: 6px;
      background-color: rgb(42, 48, 56);
      color: #ffffff;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;

      &:hover:not(:disabled) {
        background-color: var(--seed-scale-color-gray-900);
      }

      &:disabled {
        background-color: var(--seed-scale-color-gray-300);
        cursor: not-allowed;
      }
    }
  }

  .confirm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .confirm-dialog {
    background-color: var(--seed-semantic-color-paper-default);
    border-radius: 16px;
    padding: 24px;
    width: 320px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .confirm-title {
      font-size: 18px;
      font-weight: 700;
      color: var(--seed-scale-color-gray-900);
    }

    .confirm-description {
      font-size: 14px;
      color: var(--seed-scale-color-gray-600);
      margin-bottom: 16px;
    }

    .confirm-buttons {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .confirm-button {
        width: 100%;
        height: 44px;
        border: none;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;

        &.primary {
          background-color: rgb(42, 48, 56);
          color: #ffffff;

          &:hover {
            background-color: var(--seed-scale-color-gray-900);
          }
        }

        &.secondary {
          background: none;
          color: var(--seed-scale-color-gray-600);

          &:hover {
            background-color: var(--seed-scale-color-gray-100);
          }
        }
      }
    }
  }
`;
